export const PRESIGNED_FILE_KEY = 'file';

export const CACHE_STORAGE = 'cache';

export const UPLOAD_STATUS = {
  IDLE: 'IDLE',
  UPLOADING: 'UPLOADING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
};
